<template lang="pug">
  div.body.body-table.r-registry-operator-garbage-table
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
          :options="selectListOptions"
          v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            form(@submit.prevent="letSearch")
              // input(type="search" placeholder="" v-model="searchModel")
            div.parameters
              e-year-selector(year="year")
            div.actions-panel
              e-button-add(@click="addNewRowToGarbageTable")
              //button(type="button" @click="addNewRowToGarbageTable").actions-panel__button.btn-add.green

      div(v-if="operationType == 'detail'")
        e-table-editable(
          ref="detail"
          :attributes="garbageDetailAttr"
          :dataUrl="garbageDataUrl"
          :postUrl="garbagePostUrl"
          :patchUrl="garbagePatchUrl"
          :deleteUrl="garbageDeleteUrl"
          :enableOnAdd="enableOnAdd"
          :tableInOnlineMode="tableInOnlineMode"
          :afterFetchData="afterFetchData"
          :afterValidate="afterValidate"
        )

      div(v-if="operationType == 'input'")
        e-table-editable(
          ref="input"
          :attributes="garbageInputAttr"
          :dataUrl="garbageDataUrl"
          :postUrl="garbagePostUrl"
          :patchUrl="garbagePatchUrl"
          :deleteUrl="garbageDeleteUrl"
          :enableOnAdd="enableOnAdd"
          :tableInOnlineMode="tableInOnlineMode"
          :afterFetchData="afterFetchData"
          :afterValidate="afterValidate"
        )

      div(v-if="operationType == 'output'")
        e-table-editable(
          ref="output"
          :attributes="garbageOutputAttr"
          :dataUrl="garbageDataUrl"
          :postUrl="garbagePostUrl"
          :patchUrl="garbagePatchUrl"
          :deleteUrl="garbageDeleteUrl"
          :enableOnAdd="enableOnAdd"
          :tableInOnlineMode="tableInOnlineMode"
          :afterFetchData="afterFetchData"
          :afterValidate="afterValidate"
        )
</template>

<script>
  import {cadastr, tko} from '../../../api/api-endpoints.js'
  import year from '../../../utils/year.js'

  export default {
    name: 'r-registry-operator-garbage-table',
    props: {
      id: null,
      tabView: null
    },
    data () {
      return {
        operationType: null,
        year: year.getCurrentYear(),
        search: '',
        searchModel: ''
      }
    },
    computed: {
      selectListOptions () {
        return [
          {
            id: 'detail',
            name: 'Движение отходов'
          },
          {
            id: 'input',
            name: 'Сведения о полученных отходах'
          },
          {
            id: 'output',
            name: 'Сведения о переданных отходах'
          }
        ]
      },
      tableInOnlineMode () {
        return true
        // return this.$route.params.id
      },
      enableOnAdd () {
        return ['fkkoName', 'code', 'total', 'total_cubic', 'count', 'count_cubic']
      },
      garbageDetailAttr () {
        return {
          fkkoName: {
            label: 'Наименование',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название отхода',
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions
            }
          },
          code: {
            label: 'Код ФККО',
            required: true,
            placeholder: 'Выберите отход чтобы появился ФККО',
            disabled: true,
            validationRulePattern: '^((\\d*\\s*)*)$'
          },
          danger: {
            label: 'Класс опасности',
            placeholder: 'цифра',
            required: true,
            disabled: true,
            validationRulePattern: '^([1-5])$'
          },
          start_year_value: {
            label: 'Количество на начало года, тонн'
          },
          start_year_value_cubic: {
            label: 'Количество на начало года, м<sup>3</sup>'
          },
          formed: {
            label: 'Образовано, тонн'
          },
          formed_cubic: {
            label: 'Образовано, м<sup>3</sup>'
          },
          input: {
            label: 'Поступило всего, тонн'
          },
          input_cubic: {
            label: 'Поступило всего, м<sup>3</sup>'
          },
          used: {
            label: 'Использовано, тонн'
          },
          used_cubic: {
            label: 'Использовано, м<sup>3</sup>'
          },
          processed: {
            label: 'Обработано, тонн'
          },
          processed_cubic: {
            label: 'Обработано, м<sup>3</sup>'
          },
          utiled: {
            label: 'Утилизировано всего, тонн'
          },
          utiled_cubic: {
            label: 'Утилизировано всего, м<sup>3</sup>'
          },
          utiled_to_recycle: {
            label: 'Утилизировано в т.ч. с целью рециклинга, тонн'
          },
          utiled_to_recycle_cubic: {
            label: 'Утилизировано в т.ч. с целью рециклинга, м<sup>3</sup>'
          },
          utiled_from_process: {
            label: 'Утилизировано в т.ч. после обработки, тонн'
          },
          utiled_from_process_cubic: {
            label: 'Утилизировано в т.ч. после обработки, м<sup>3</sup>'
          },
          neutral: {
            label: 'Обезврежено всего, тонн'
          },
          neutral_cubic: {
            label: 'Обезврежено всего, м<sup>3</sup>'
          },
          neutral_from_process: {
            label: 'Обезврежено в т.ч. после обработки, тонн'
          },
          neutral_from_process_cubic: {
            label: 'Обезврежено в т.ч. после обработки, м<sup>3</sup>'
          },
          output: {
            label: 'Передано всего, тонн'
          },
          output_cubic: {
            label: 'Передано всего, м<sup>3</sup>'
          },
          storage: {
            label: 'Размещено для хранения, тонн'
          },
          storage_cubic: {
            label: 'Размещено для хранения, м<sup>3</sup>'
          },
          burial: {
            label: 'Размещено для захоронения, тонн'
          },
          burial_cubic: {
            label: 'Размещено для захоронения, м<sup>3</sup>'
          },
          end_year_value: {
            label: 'Количество на конец года, тонн'
          },
          end_year_value_cubic: {
            label: 'Количество на конец года, м<sup>3</sup>'
          }
        }
      },
      garbageInputAttr () {
        return {
          garbage_source_input_id: {
            label: 'Источник',
            validationRulePattern: '(\\.*)',
            placeholder: ''
          },
          fkkoName: {
            label: 'Наименование',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название отхода',
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions
            }
          },
          code: {
            label: 'Код ФККО',
            required: true,
            placeholder: ' ',
            disabled: true,
            validationRulePattern: '^((\\d*\\s*)*)$'
          },
          danger: {
            label: 'Класс опасности',
            required: true,
            disabled: true,
            placeholder: 'цифра',
            validationRulePattern: '^([1-5])$'
          },
          organization: {
            label: 'Организация-поставщик',
            validationRulePattern: '(\\.*)',
            placeholder: ''
          },
          region: {
            label: 'Регион',
            validationRulePattern: '(\\.*)',
            placeholder: ''
          },
          count: {
            label: 'Количество отходов, тонн',
            required: true
          },
          count_cubic: {
            label: 'Количество отходов, м<sup>3</sup>'
          }
        }
      },
      garbageOutputAttr () {
        return {
          fkkoName: {
            label: 'Наименование',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название отхода',
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions
            }
          },
          code: {
            label: 'Код ФККО',
            required: true,
            placeholder: ' ',
            disabled: true,
            validationRulePattern: '^((\\d*\\s*)*)$'
          },
          danger: {
            label: 'Класс опасности',
            required: true,
            disabled: true,
            placeholder: 'цифра',
            validationRulePattern: '^([1-5])$'
          },
          organization: {
            validationRulePattern: '(\\.*)',
            placeholder: '',
            label: 'Организация, которой переданы отходы'
          },
          direction: {
            label: 'Направление'
          },
          use: {
            label: 'Передано для использования'
          },
          transport: {
            label: 'Передано для транспортирования'
          },
          processing: {
            label: 'Передано на обработку'
          },
          utilization: {
            label: 'Передано на утилизацию'
          },
          neutralization: {
            label: 'Передано для обезвреживания'
          },
          storage: {
            label: 'Передано на хранение'
          },
          burial: {
            label: 'Передано на захоронение'
          },
          total: {
            label: 'Всего, тонн',
            required: true
          },
          total_cubic: {
            label: 'Всего, м<sup>3</sup>'
          }
        }
      },
      garbageDataUrl () {
        if (this.id) {
          let routeQuery = {
            query: {
              sourceId: this.id,
              year: this.year,
              type: this.operationType,
              garbage_type: 'default'
            }
          }
          if (this.search) {
            routeQuery.query.q = this.search
          }

          return tko.operatorGarbageOperation(routeQuery)
        }
        // // if new record, offline save
        // return tkoOffline.operatorGarbageTable(this.$route.name, this.year, this.operationType)
      }
    },
    methods: {
      afterValidate (ctx, model, errors, els) {
        let {tr} = els
        if (errors.danger) {
          delete errors.danger
          errors.fkkoName = 'Выберите отход'
        }
        if (errors.code) {
          delete errors.code
          errors.fkkoName = 'Выберите отход'
        }

        if (errors.fkkoName) {
          if (tr) {
            try {
              tr.querySelector('[name="fkkoName"]').focus()
            } catch (e) {
              console.error(e)
            }
          }
        }

        return errors
      },
      afterFetchData (ctx, data) {
        for (let i = 0; i < data.data.length; i++) {
          data.data[i].garbage_type = 'default'
          if (data.data[i].fkko) {
            data.data[i].fkkoName = data.data[i].fkko.name

            if (!data.data[i].code) {
              data.data[i].code = data.data[i].fkko.code
            }

	          if (data.data[i].organization && data.data[i].organization_id) {
		          data.data[i].organization = data.data[i].organization.name
	          }

          } else {
            data.data[i].fkkoName = ''
          }
        }

        // console.log(data.data)
        return data
      },
      onSelect (ctx, $event, model, attr) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.code = copy.code
          model.fkko_id = copy.id
          model.fkkoName = copy.fkkoName
          model.fkko = {name: copy.fkkoName}
          model.danger = copy.danger
        } else {
          model.code = ''
          model.fkko_id = ''
          model.fkkoName = ''
          model.fkko = {name: ''}
          model.danger = ''
        }
      },
      suggestionEndpoint (ctx, q) {
        return cadastr.fkko({query: {q: q, 'per-page': 50}})
      },
      transformSuggestions (ctx, response) {
        let data = response.data
        let options = []
        for (let i = 0; i < data.length; i++) {
          options.push({
            name: data[i].code + ' ' + data[i].name,
            fkkoName: data[i].name,
            id: data[i].id,
            code: data[i].code,
            danger: data[i].danger
          })
        }
        return options
      },
      garbagePostUrl (context, model) {
        return tko.operatorGarbageOperationPost({
          query: {
            sourceId: this.id,
            year: this.year,
            type: this.operationType
          }
        })
      },
      garbagePatchUrl (context, model) {
        return tko.operatorGarbageOperationPatch({
          query: {
            sourceId: model.id,
            year: model.year,
            type: this.operationType
          }
        })
      },
      garbageDeleteUrl (context, model) {
        return tko.operatorGarbageOperationDelete({
          query: {
            sourceId: model.id,
            year: model.year,
            type: this.operationType
          }
        })
      },
      addNewRowToGarbageTable () {
        const Model = () => {
          return {
            code: '',
            danger: '',
            garbage_type: 'default',
            // can be used for turn year select
            _operationType: JSON.parse(JSON.stringify(this.operationType)),
            _year: JSON.parse(JSON.stringify(this.year))
          }
        }
        if (this.operationType === 'detail') {
          this.$refs.detail.createRow(new Model())
        } else if (this.operationType === 'input') {
          this.$refs.input.createRow(new Model())
        } else if (this.operationType === 'output') {
          this.$refs.output.createRow(new Model())
        }
      }
    }
  }
</script>
